import useGetCompanyProductsByUser from "hooks/User/GetProductsByUser/useGetProductsByUser";
import { useEffect, useState } from "react";
import { useKontentItems } from "../useGetItems/useGetItems";
import { TermsAndConditionsResolver } from "models/cms/kontent_model/Resolvers/GlobalSite/TermsAndCondtions";
import { TermsAndConditions } from "types/CMS/Unum/GlobalSite/TermsAndCondtions";

const useCMSTermsAndCondtions = () => {
  const { companyProductsByUser } = useGetCompanyProductsByUser();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined>(undefined);
  const [termsAndConditions, setTermsAndConditions] = useState<TermsAndConditions|undefined>(undefined);

  const { fetchData } = useKontentItems({
    type: "site",
    resolver:TermsAndConditionsResolver.resolve,
    depth: 10,
  });

  useEffect(() => {
    const loadNavItems = async () => {
      setIsLoading(true);
      setError(undefined);
      try {
        const kontent = await fetchData();
        if (kontent.isError || !kontent?.data) {
          setError("Failed to load Terms and Conditions");
          setIsLoading(false);
          setTermsAndConditions(undefined);
          return;
        }
        setTermsAndConditions(kontent.data.result);
      } catch {
        setError("Failed to load Terms and Conditions");
      }
      setIsLoading(false);
    };
    loadNavItems();
  }, [companyProductsByUser]);

  return { error, isLoading, termsAndConditions };
};

export default useCMSTermsAndCondtions;
